import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import "./Why_Should_Use.css";

// Replace with dynamic data structure similar to Branding_Why_Choose_Us
const data = [
  {
    id: 2,
    whyShouldUseData: [
      { title: "E-commerce Businesses", descn: "Looking to increase sales quickly." },
      { title: "Local Businesses", descn: "Aiming to attract nearby customers." },
      { title: "Enterprises", descn: "Launching new products or services." },
      { title: "Companies", descn: "Wanting to dominate competitive markets." },
    ],
  },
  
  {
    id: 5,
    whyShouldUseData: [
      { title: "Businesses Receiving Online Reviews", descn: "From platforms like Google, Yelp, or social media." },
      { title: "Brands Facing Negative Publicity", descn: "Or misinformation." },
      { title: "Startups and Growing Companies", descn: "Looking to build a credible online presence." },
      { title: "Established Organizations", descn: "Aiming to maintain and improve customer trust." },
    ],
  },
  
  {
    id: 6,
    whyShouldUseData: [
      { title: "Small and Medium-Sized Businesses", descn: "Looking to increase online visibility." },
      { title: "E-commerce Websites", descn: "Aiming to drive more traffic and sales." },
      { title: "Local Businesses", descn: "Wanting to attract nearby customers." },
      { title: "Established Companies", descn: "Seeking to maintain their competitive edge online." },
    ],
  },
  

  {
    id: 9,
    whyShouldUseData: [
      { title: "E-commerce Businesses", descn: "Drive sales with exclusive offers and product updates." },
      { title: "Retail Brands", descn: "Promote discounts, events, and seasonal deals." },
      { title: "Service Providers", descn: "Share appointment reminders, updates, or follow-ups." },
      { title: "Startups", descn: "Quickly establish connections and build brand awareness." },
      { title: "Educational Institutions", descn: "Notify students or parents about important updates." },
      { title: "Nonprofits", descn: "Share fundraising or event details to engage donors and supporters." },
    ],
  },

  {
    id: 10,
    whyShouldUseData: [
      { title: "E-commerce Stores", descn: "Announce flash sales, discounts, and product launches." },
      { title: "Retailers", descn: "Share seasonal offers, loyalty program updates, or store events." },
      { title: "Service Providers", descn: "Send appointment reminders, confirmations, or service alerts." },
      { title: "Startups", descn: "Quickly build awareness and connect with a large audience base." },
      { title: "Financial Institutions", descn: "Notify customers about account updates, transactions, or promotions." },
      { title: "Event Organizers", descn: "Share event details, reminders, or last-minute changes." },
    ],
  }
  
  
  
];

function Why_Should_Use() {
  const [whyShouldUseData, setWhyShouldUseData] = useState([]);
  const { id } = useParams(); // Get the 'id' from the URL params

  // Filter the data based on the 'id' from the URL
  useEffect(() => {
    const filteredData = data.filter((item) => item.id === Number(id));
    if (filteredData.length > 0) {
      setWhyShouldUseData(filteredData[0].whyShouldUseData);
    }
  }, [id]);

  return (
    <section className="Why_Should_Use">
      <div className="container">
        <div className="title_div">
          <p className="title">Why Should Use</p>
        </div>

        <div className="main_data_holder">
          <div className="row">
            <div className="col-lg-3 col-md-12 col-sm-12">
              <div className="row">
                {whyShouldUseData.slice(0, 2).map((items, index) => (
                  <div key={index} className="col-lg-12 col-md-6 col-sm-6 col-6 mb-3">
                    <div className="main_img_holder">
                      <div className="img_holder">
                        <img
                          src={`/Assets/Images/Service/Services/digital_media/why_should_use/img${index + 1}.png`}
                          className="img"
                          alt={items.title}
                        />
                      </div>

                      <div className="overlay_colour"></div>

                      <div className="text_container">
                        <p className="heading_text">{items.title}</p>
                        <p className="sub_text">{items.descn}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="col-lg-4 col-md-6 col-sm-6 col-sm-4 mb-3">
              <div className="second_main_img_holder main_img_holder">
                {whyShouldUseData.slice(2, 3).map((items, index) => (
                  <div key={index} className="second_img_holder">
                    <img
                      src={`/Assets/Images/Service/Services/digital_media/why_should_use/img3.png`}
                      className="secondimg"
                      alt={items.title}
                    />
                    <div className="overlay_colour"></div>

                    <div className="text_container">
                      <p className="heading_text">{items.title}</p>
                      <p className="sub_text">{items.descn}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="col-lg-5 col-md-6 col-sm-6 col-sm-5 mb-3">
              <div className="third_main_img_holder main_img_holder">
                {whyShouldUseData.slice(3, 4).map((items, index) => (
                  <div key={index} className="third_img_holder">
                    <img
                      src={`/Assets/Images/Service/Services/digital_media/why_should_use/img4.png`}
                      className="thirdimg"
                      alt={items.title}
                    />
                    <div className="overlay_colour"></div>

                    <div className="text_container">
                      <p className="heading_text">{items.title}</p>
                      <p className="sub_text">{items.descn}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Why_Should_Use;
